import { render, staticRenderFns } from "./TeamSeatModal.vue?vue&type=template&id=46d45644&scoped=true"
import script from "./TeamSeatModal.vue?vue&type=script&lang=js"
export * from "./TeamSeatModal.vue?vue&type=script&lang=js"
import style0 from "./TeamSeatModal.vue?vue&type=style&index=0&id=46d45644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d45644",
  null
  
)

export default component.exports